import React from "react";
import { Navigate } from "react-router-dom";
import { UseAuthContext } from "../store/contexts/auth.context";

function IsSignedInRoute({ children }) {
  const { isLogged } = UseAuthContext();
  return !isLogged ? children : <Navigate to="/" replace />;
}

export default IsSignedInRoute;
